import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import {  TextAreaField, DropdownListField } from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { faqs } from '../../../constants/settingTypes';


const validate = (values) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }
    required('Question');
    required('Answer');    
    required('Order');    
    return errors;
}

let EditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
        
    }

    _onSubmit(values) {        
        this.props.onSubmit(values);
    }
    
    
    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError,
            listData,
            } = this.props;
        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;
        let listNewOrder = []; 
        for(let i=0; i < listData.length; i++)
        listNewOrder.push(listData[i].Order);
       
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новый вопрос' : 'Редактирование вопроса'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal'>    
                        <Field name='Question' component={TextAreaField} label='Вопрос' />
                        <Field name='Answer' component={TextAreaField} label='Ответ' />  
                               
                        <Field component={DropdownListField} 
                            data={listNewOrder} 
                            label='Приоритет' 
                            name='Order'
                            textField='Order' 
                            valueField= 'Order'          
                        />       
                        {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                        <p>ОШИБКА!</p>
                        {crudError && <p>{crudError}</p>}
                    </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}
EditModal = reduxForm({
    form: 'faqToEdit',
    validate, 
})(EditModal);

EditModal = connect(state => ({
    fetching: state.application.get('settings')[faqs].updateFetching,
    crudError: state.application.get('settings')[faqs].updateError
}))(EditModal);

export default EditModal;


// WEBPACK FOOTER //
// ./src/components/settings/faq/EditModal.jsx